<div class="auth-container">
    <h2>MonPharmacien</h2>
    <div class="auth-form">
        <h3>Authentification</h3>
        <p>Bonjour {{pharmacieAuth.prenomTitulaire}} {{pharmacieAuth.nomTitulaire}},<br >
            Pour vous connecter à l'application, veuillez saisir le code transmis par mail à l'adresse <b>{{pharmacieAuth.emailTitulaire}}</b>
        </p>
        <div class="wrong-code-container" *ngIf="wrongCode">
            <span class="invalid-feedback">Code d'accès incorrect</span>
        </div>
        <form *ngIf="authForm" [formGroup]="authForm" (ngSubmit)="onSubmit()">
            <div class="section section-auth">

                <div *ngIf="submitted && field.code.errors" class="invalid-feedback">
                    <div *ngIf="field.code.errors.required">Le code d'accès est requis</div>
                </div>
                <div class="form-group row">
                    <div class="section-auth-form-label offset-md-2 offset-sm-0 col-md-4 col-sm-6">
                        <label>Code d'accès : </label>
                    </div>
                    <div class="section-auth-form-input col-md-4 col-sm-6">
                        <input type="password" formControlName="code"
                            [ngClass]="{'is-invalid': submitted && field.code.errors }" />
                    </div>
                </div>

                <div class="form-group section-auth-form-button">
                    <button type="submit" class="btn btn-giphar" [disabled]="sending">Se connecter</button>
                </div>

            </div>
        </form>
    </div>
</div>